import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { faEdit, faTrash, faUndo } from '@fortawesome/free-solid-svg-icons';
import { UserService } from 'src/app/Services/User/user.service';
import { first } from 'rxjs/operators';
import { AlertService } from 'src/app/Services/User/alert.service';
import { ToastService } from 'src/app/Services/toast/toast.service';

@Component({
  selector: 'app-gestion-alumni',
  templateUrl: './gestion-alumni.component.html',
  styleUrls: ['./gestion-alumni.component.scss'],
})
export class GestionAlumniComponent implements OnInit {
  isModalOpen = false;
  form: FormGroup;
  submitted = false;
  id: any;
  ListAlumni: any;
  alumni: any = {};
  any: any;
  closeResult: string;
  nom :string;
  date: string;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private alertService: AlertService,
    private userService: UserService,
    private toast: ToastService,
    private modalService:NgbModal
  ) {}

  ngOnInit(): void {
    this.getalumnibyclubid();
    this.form = this.formBuilder.group({
      nom: ['', Validators.required],
      prenom: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      tel: [
        '',
        [Validators.required, Validators.minLength(8), Validators.maxLength(8)],
      ],
      sex: ['', [Validators.required]],
      session: ['', Validators.required],
      departement: ['', Validators.required],
      awards: ['', Validators.required],
    });
  }

  get f() {
    return this.form.controls;
  }

  SearchPostByTitre() {
    if (this.nom != '') {
      this.ListAlumni = this.ListAlumni.filter((res) => {
        return res.titre.toLowerCase().match(this.nom.toLowerCase());
      });
    } else if (this.nom == '') {
      this.getalumnibyclubid();
    }
  }

  SearchPostByDate() {
    if (this.date != '') {
      this.ListAlumni = this.ListAlumni.filter((res) => {
        return res.date.toLowerCase().match(this.date.toLowerCase());
      });
    } else if (this.date == '') {
      this.getalumnibyclubid();
    }
  }

  openalert(contentalert) {
    this.modalService
      .open(contentalert, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openModal() {
    const modal = document.getElementById('myModal');
    modal.style.display = 'block';
  }
  openUpdateModal(alumniId: any) {
    this.getalumnibyid(alumniId); // Fetch alumni details by ID
    const updateModal = document.getElementById('updateModal');
    updateModal.style.display = 'block';
  }

  populateUpdateForm() {
    this.form.patchValue({
      nom: this.alumni.nom,
      prenom: this.alumni.prenom,
      email: this.alumni.email,
      tlf: this.alumni.tlf,
      sex: this.alumni.sex,
      session: this.alumni.session,
      departement: this.alumni.departement,
      awards: this.alumni.awards,
    });
  }

  getalumnibyid(alumniId: any) {
    this.userService.getAlumibyId(alumniId).subscribe((response) => {
      this.alumni = response;
      return this.alumni;
      this.populateUpdateForm();
    });
  }

  closeUpdateModal() {
    const updateModal = document.getElementById('updateModal');
    updateModal.style.display = 'none';
  }

  closeModal() {
    const modal = document.getElementById('myModal');
    modal.style.display = 'none';
  }
  deleteAlumni(){
    this.userService.deleteUser(sessionStorage.getItem('IdAlumni'))
    .subscribe((data)=>{
      this.toast.SuccessToast("Alumni Deleted");
      return data ; 
    })
  }

  onSubmit() {
    this.id = localStorage.getItem('Id');
    this.submitted = true;

    // Stop here if the form is invalid
    if (this.form.invalid) {
      return;
    }

    this.userService
      .Addalumnibyclub(this.id, this.form.value)
      .pipe(first())
      .subscribe(
        (data) => {
          this.toast.SuccessToast('Alumni Added!');
          // Do something with the response data if needed
        },
        (error) => {
          this.toast.ErrorToast(error);
          // Handle the error
        }
      );

    this.form.reset();
    this.submitted = false;
  }

  getalumnibyclubid() {
    this.id = localStorage.getItem('Id');
    this.userService.getAlumnibyClub(this.id).subscribe((data) => {
      this.ListAlumni = data;
      return this.ListAlumni;
    });
  }
  setAlumniId(id: any) {
    sessionStorage.setItem('IdAlumni', id);
  }

  updatealumni(id: any) {}
}